import { render, staticRenderFns } from "./EmployeeViewNovi.vue?vue&type=template&id=6f31b4fc&scoped=true"
import script from "./EmployeeViewNovi.vue?vue&type=script&lang=js"
export * from "./EmployeeViewNovi.vue?vue&type=script&lang=js"
import style0 from "./EmployeeViewNovi.vue?vue&type=style&index=0&id=6f31b4fc&prod&scoped=true&lang=css"
import style1 from "./EmployeeViewNovi.vue?vue&type=style&index=1&id=6f31b4fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f31b4fc",
  null
  
)

export default component.exports